import axios from 'axios';

export default class psCalendar {
    constructor(el) {
        if (!el) {
            return;
        }

        this.el = el;

        this.list = this.el.querySelector('.ps-calendar-list');
        this.listLoader = this.list && this.list.querySelector('.ajax-loading');
        this.listDiv = document.getElementById("calendarDiv");

        this.filters = this.el.querySelector('.ps-filter-list');
        this.filterLoader = this.filters && this.filters.querySelector('.ajax-loading');

        this.page = parseInt(this.listDiv.getAttribute('data-page')) || 1;
        this.itemsPerPage = parseInt(this.listDiv.getAttribute('data-items-per-page')) || 3;
        this.isPsStartPage = this.listDiv.getAttribute('data-ispsstartpage');

        this.prev = this.list.querySelector(".pagination-button.prev");
        this.next = this.list.querySelector(".pagination-button.next");

        this.calendarBlock = parseInt(this.listDiv.getAttribute('data-items-calendar-event-id'));
        this._initPagination();
        this._initFiltering();
    }

    _initPagination() {
        const eventHandler = event => {
            event.preventDefault();

            if (event.target.hasAttribute('disabled')) {
                return;
            }

            const page = event.target === this.prev ? this.page - 1 : this.page + 1;
            const pageMax = Math.ceil(this._getTotalItemCount() / this.itemsPerPage);

            if (page < 1 || pageMax < page) {
                return;
            }

            this._update(false, page);
        };

        this.prev.addEventListener('click', eventHandler);
        this.next.addEventListener('click', eventHandler);
    }

    _initFiltering() {
        this.filters && this.filters.addEventListener('change', event => {
            if (event.target.tagName === 'INPUT' && event.target.type === 'checkbox') {
                this._update(true);
            }
        });
    }

    _update(updateProfile, page) {
        const loader = page ? this.listLoader : this.filterLoader;
        page = page || 1;

        this._toggleLoader(loader, true);

        let data, url;

        if (this.calendarBlock > 0) {
            url = "/api/calendar";
            data = new FormData();
            data.append('calendarEventListingId', this.calendarBlock);
        } else {
            const form = this.filters.querySelector('form');
            url = form.action;
            data = new FormData(form);
        }

        data.append('page', page);
        data.append('pagelimit', this.itemsPerPage);
        data.append('updateProfile', updateProfile === true);
        data.append('isPsStartPage', this.isPsStartPage);

        axios.post(url, data)
            .then(response => {
                this.listDiv.innerHTML = response.data;
                this.listDiv.setAttribute('data-page', page);
                this.page = page;
                this.totalItemCount = this._getTotalItemCount();
                this._updatePagination();
            })
            .catch(error => {
                this.listDiv.innerHTML = error.status;
            })
            .finally(() => {
                this._toggleLoader(loader, false);
            });
    }

    _getTotalItemCount() {
        const wrapper = document.getElementById("ps-calendar-wrapper");
        return wrapper && parseInt(wrapper.getAttribute('data-total-item-count'));
    }

    _toggleLoader(element, state) {
        element.toggleAttribute('hidden', !state);
    }

    _updatePagination() {
        const disablePrev = this.page === 1;
        this.prev.toggleAttribute("disabled", disablePrev);

        const pageMax = Math.ceil(this._getTotalItemCount() / this.itemsPerPage);
        const disableNext = pageMax <= this.page;
        this.next.toggleAttribute("disabled", disableNext);

        const counter = this.el.querySelector('.ps-calendar-list__pagination-and-filter .pagination-counter');
        counter && (counter.innerHTML = this.page + ' / ' + pageMax);
    }
}
